export default "__VITE_ASSET__m4XlF3za__"